import debug from 'debug';

import {
  API_CLIENT__START_REQUEST,
  API_CLIENT__END_REQUEST,
  API_CLIENT__ERROR,
} from '../applications/researcher/redux/constants';

import {
  getBeginType,
  getErrorType,
} from '../applications/researcher/redux/api-client/selectors.api-client';

import getFakeEndpointResponse from './faux-client.response';

const debugEvent = debug('test:faux-client');
const debugError = debug('test:faux-client:error');

export function configAuth() {}

const resolver = (event) => (dispatch) => {
  const originalType = event.type;
  dispatch({
    ...event,
    apiClientType: API_CLIENT__START_REQUEST,
    originalType,
    type: getBeginType(originalType),
  });

  return getFakeEndpointResponse(event.url)
    .then(({ data }) => {
      debugEvent(originalType, data);
      dispatch({
        ...event,
        apiClientType: API_CLIENT__END_REQUEST,
        data,
      });
      return data;
    })
    .catch((error) => {
      debugError(originalType, error);
      dispatch({
        ...event,
        apiClientType: API_CLIENT__ERROR,
        error,
        originalType,
        type: getErrorType(originalType),
      });
      return error;
    });
};

export default resolver;
